import DownloadIcon from "@material-ui/icons/GetApp";
import { Button } from "ra-ui-materialui/lib/button";
import React, { useMemo, useState } from "react";
import { Parser } from "json2csv";
import fileDownload from "js-file-download";
import { useDataProvider, useListContext, useNotify } from "react-admin";
import { useSelector } from "react-redux";
import { ReduxState } from "ra-core";

const ExportButton = () => {
  const { filter, filterValues } = useListContext();
  const provider = useDataProvider();
  const notify = useNotify();

  const [isCSVLoading, setCSVLoading] = useState(false);
  const [progress, setProgress] = useState<{
    current: number | null;
    total: number | null;
  }>({
    current: 0,
    total: 0,
  });

  const navMode = useSelector((state: ReduxState) => state.navMode);

  const exportCSV = () => {
    if (isCSVLoading) return;

    provider
      .getRecordForCSV("ccaStudentRenewals", {
        filter: { ...filter, ...filterValues },
        body: { filter },
        callback: ({ isLoading, loadedRecordCount, totalRecords }: any) => {
          // Only update loading state once at start and end
          if (isLoading !== undefined) {
            setCSVLoading(isLoading);
          }

          setProgress({
            current: loadedRecordCount,
            total: totalRecords,
          });
        },
      })
      .then(({ data }: any) => {
        const parser = new Parser();
        const csvData = data.flat();
        fileDownload(
          parser.parse(csvData),
          `CCA Student Renewal Records - ${navMode.school.name}.csv`,
        );
      })
      .catch((err: any) => {
        notify("Failed to retrieve records, please try again", "warning");
      })
      .finally(() => {
        // Reset loading state and progress regardless of success or failure
        setCSVLoading(false);
        setProgress({
          current: null,
          total: null,
        });
      });
  };

  const downloadText = useMemo(() => {
    if (!isCSVLoading) {
      return "Export";
    }

    if (progress.current !== null && progress.total !== null) {
      return `Fetching Data ${progress.current}/${progress.total}`;
    }

    return "Downloading CSV";
  }, [isCSVLoading, progress]);

  return (
    <Button onClick={exportCSV} label={downloadText}>
      <DownloadIcon />
    </Button>
  );
};

export default ExportButton;
